"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LSGTMContainer = exports.LSEnvDomainPrefixes = exports.LSEnvDomainPrefix = exports.LSEnv = void 0;
var LSEnv;
(function (LSEnv) {
    LSEnv["Dev"] = "dev";
    LSEnv["Local"] = "local";
    LSEnv["Prod"] = "prod";
    LSEnv["Uat"] = "uat";
})(LSEnv = exports.LSEnv || (exports.LSEnv = {}));
var LSEnvDomainPrefix;
(function (LSEnvDomainPrefix) {
    LSEnvDomainPrefix["Dev"] = "dev-";
    LSEnvDomainPrefix["Local"] = "-local";
    LSEnvDomainPrefix["Prod"] = "";
    LSEnvDomainPrefix["Uat"] = "uat-";
})(LSEnvDomainPrefix = exports.LSEnvDomainPrefix || (exports.LSEnvDomainPrefix = {}));
exports.LSEnvDomainPrefixes = {
    [LSEnv.Dev]: LSEnvDomainPrefix.Dev,
    [LSEnv.Local]: LSEnvDomainPrefix.Local,
    [LSEnv.Prod]: LSEnvDomainPrefix.Prod,
    [LSEnv.Uat]: LSEnvDomainPrefix.Uat,
};
var LSGTMContainer;
(function (LSGTMContainer) {
    LSGTMContainer["InternalCustomerService"] = "INTERNAL - Customer Service";
    LSGTMContainer["PlatformGeneric"] = "PLATFORM - Fallback";
})(LSGTMContainer = exports.LSGTMContainer || (exports.LSGTMContainer = {}));
//# sourceMappingURL=interface.js.map